import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';
import { get } from 'lodash';

@Component({
  selector: 'option-text',
  styleUrls: ['./option-text.component.scss'],
  templateUrl: './option-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionTextComponent extends OptionComponent {
  get textAnswer(): string {
    return get(this.reply.getCheck(this.option, this.as), 'value');
  }
  set textAnswer(v: string) {
    this.reply.toggle(this.option, v ? v : null);
  }
}
